import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Policy, PolicyDetails, UmbrellaPolicy } from '@amfam/policy/models';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { PolicyChangeRequestType } from '@amfam/shared/models';
import { ScrollService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'umbrella-risk-card',
  templateUrl: './umbrella-risk-card.component.html',
  styleUrls: ['./umbrella-risk-card.component.scss', '../policy-risk-card.scss'],
  standalone: false
})
export class UmbrellaRiskCardComponent {
  public policy: UmbrellaPolicy;

  @Input() newAFIRiskCard = false;
  @Input() underLyingPolicies = [];

  constructor(
    private scrollService: ScrollService,
    private router: Router,
    private analyticsFacade: AnalyticsFacade
  ) {}

  onPolicyChange(policy: Policy) {
    this.policy = <UmbrellaPolicy>policy;
  }
  requestPolicyChange() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonRequestPolicyChange);

    this.router.navigate(['/policies/changerequest'], {
      state: { changeRequestType: PolicyChangeRequestType.POLICY_COVERAGE_CHANGE }
    });
  }
  getDocuments() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkDocuments);
    this.scrollService.scrollToElement('documentsCard', 205);
  }
  fileClaim() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonFileAClaim);
    this.router.navigate(['/claims/report-claim-fnol']);
  }
}
